module.exports = __webpack_public_path__ + "img/AT0000002473831.01d36ea4.png";